import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Icon from 'dpl/common/components/Icon';
import { isLessThanBreakpoint } from 'dpl/util/grid';

const IS_LT_MD = isLessThanBreakpoint('md');

export default function SuggestedLocationButton({ locationName, onClick }) {
  const [hovered, setHovered] = useState(false);

  function handleClick() {
    setHovered(true);
    setTimeout(onClick, IS_LT_MD ? 250 : 0);
  }

  function handleMouseEnter() {
    if (IS_LT_MD) return;
    setHovered(true);
  }

  function handleMouseLeave() {
    if (IS_LT_MD) return;
    setHovered(false);
  }

  return (
    <button
      type="button"
      className={classnames(
        'SuggestedLocationButton font-16 ba b--default br3 w-100 pv4 ph4',
        { 'bg-gray-100': hovered, transition: !IS_LT_MD }
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <div className="flex items-center gap-16">
        <div
          className={classnames('ba b--default br3 pv2 ph2', {
            'bg-stone-700 white': hovered,
            transition: !IS_LT_MD
          })}
        >
          <Icon name="fetch-location" height="24px" width="24px" />
        </div>
        <div className="lh-title">
          <p className="font-16">Your location</p>
          <p className="font-14 secondary">{locationName}</p>
        </div>
      </div>
    </button>
  );
}

SuggestedLocationButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  locationName: PropTypes.string.isRequired
};
